import { InputField } from 'components/Global';

const DetailPartner = ({ data, selectedCountry }) => {
  return (
    <div className="detail-order__partner-detail">
      <div className="detail-order__partner-detail-title">
        <h1>Informasi Partner</h1>
      </div>

      <div className="detail-order__partner-detail-body">
        <InputField label="Nama Lengkap" disabled value={data?.vendor_partnership?.name || '-'} />
        <InputField label="Email" disabled value={data?.vendor_partnership?.email || '-'} />
        <div className="detail-order__partner-detail-body__phone-number">
          <InputField
            label="No Handphone"
            disabled
            value={data?.vendor_partnership?.phone_code || '-'}
            icon={
              <img
                src={`https://flagcdn.com/w2560/${selectedCountry?.code?.toLowerCase()}.png`}
                width={26}
                height={16}
                alt={selectedCountry?.name + ' nation flag'}
              />
            }
          />
          <InputField value={data?.vendor_partnership?.phone || '-'} disabled />
        </div>
      </div>
    </div>
  );
};

export default DetailPartner;
